import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "axios"

const { REACT_APP_API_ROUTE: API_ROUTE } = process.env

const initialState = {
  status: "idle",
  data: null,
  totalElements: 0,
  totalPages: 0,
  error: "",
}

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // find-all
      .addCase(findAllUser.pending, (state, _) => {
        state.status = "loading"
      })
      .addCase(findAllUser.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.data = action.payload.page
        state.totalElements = action.payload.totalElements
        state.totalPages = action.payload.totalPages
      })
      .addCase(findAllUser.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })

      // save
      .addCase(saveUser.pending, (state, _) => {
        state.status = "loading"
      })
      .addCase(saveUser.fulfilled, (state, action) => {
        state.status = "succeeded"
        let data = [...state.data]
        data = data.map((item) =>
          item.id === action.payload.id ? action.payload : item
        )
        state.data = data
      })
      .addCase(saveUser.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })

      // delete
      .addCase(deleteUser.pending, (state, _) => {
        state.status = "loading"
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.status = "succeeded"
        let data = [...state.data]
        data = data.filter((item) => item.id !== action.payload.id)
        state.data = data
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const findAllUser = createAsyncThunk(
  "/user/find-all",
  async (
    {
      start = 0,
      limit = 75,
      id = "%",
      role,
      personType,
      name = "%",
      surname = "%",
      businessName = "%",
      ruc = "%",
      state = 1,
      jwt,
    },
    thunkAPI
  ) => {
    try {
      const endpoint = `/user/console?start=${start}&limit=${limit}&id=%25${id}%25&role=${role}&person-type=${personType}&name=%25${name}%25&surname=%25${surname}%25&business-name=%25${businessName}%25&ruc=%25${ruc}%25&state=${state}`
      const { data } = await axios.get(API_ROUTE + endpoint, {
        headers: { Authorization: jwt },
      })
      return thunkAPI.fulfillWithValue(data)
    } catch (ex) {
      console.log(ex)
      return thunkAPI.rejectWithValue(ex.message)
    }
  }
)

export const saveUser = createAsyncThunk(
  "/user/save",
  async ({ user, jwt }, thunkAPI) => {
    try {
      const endpoint = `/user`
      const { data } = await axios.post(API_ROUTE + endpoint, user, {
        headers: { Authorization: jwt },
      })
      return thunkAPI.fulfillWithValue(data)
    } catch (ex) {
      console.log(ex)
      return thunkAPI.rejectWithValue(ex.message)
    }
  }
)

export const deleteUser = createAsyncThunk(
  "/user/delete",
  async ({ id, jwt }, thunkAPI) => {
    try {
      const endpoint = `/user/${id}`
      await axios.delete(API_ROUTE + endpoint, {
        headers: { Authorization: jwt },
      })
      return thunkAPI.fulfillWithValue({ id })
    } catch (ex) {
      console.log(ex)
      return thunkAPI.rejectWithValue(ex.message)
    }
  }
)

export const getUser = (state) => state.user
export default userSlice.reducer
